import axios from 'axios'
import qs from 'qs'
import isEmpty from 'lodash/isEmpty'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BJH_API, // api 的 base_url
  timeout: 100000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (config.data) {
    config.data = qs.stringify(config.data)
  }
  config.params = config.params || {}
  const token = getToken()
  if (token) {
    config.params.passport = getToken()
  }
  // get method, params object to url query string
  // avoid param value contains url bug
  config.url += isEmpty(config.params) ? '' : ('?' + qs.stringify(config.params))
  config.params = null
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.error) {
      const error = res.messages.error
      let message = ''
      if (error.code === 'login_required' || error.code === 'login_account_expired' || error.code === 'login_account_denied') {
        message = error.message
        SingleLogin.getInstance(message)
      } else {
        if (res.code === 500 && error.code === 'internal_error') {
          message = '内部错误：' + error.message
        } else {
          message = '其他错误：' + error.message
        }
        Message({
          message: message,
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.resolve(false)
    } else {
      return res.messages
    }
  },
  error => {
    console.log(error.message) // for debug
    Message({
      message: 'Reject：' + error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

const SingleLogin = (function() {
  function Singleton(message) {
    MessageBox.confirm(
        '你已被登出，可以取消继续留在该页面，或者重新登录',
        '确定登出',
        {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }
    ).then(() => {
      store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    })
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
  }
  // 实例容器
  let instance
  const _static = {
    // 返回Singleton的实例
    getInstance: function(args) {
      if (instance === undefined) {
        instance = new Singleton(args)
      }
      return instance
    }
  }
  return _static
})()

export default service
